define('common', ['jquery', 'app', 'globalFunctions'], function($, app, globalFunctions) {
  var component = {};

  window.siteObj.fn = globalFunctions();

  component.setupFunction2 = function() {
    if (window.siteObj.features.persistentBasket.show === 'true') {
      var jsonFile = 'basketinfo.json';
      var testurl = window.siteObj.siteNonSecureURL + jsonFile;
      var $basketQuantity = $('.basket-item-qty');
      if (location.protocol === 'https:') {
        testurl = window.siteObj.siteSecureURL + 'basketinfo.json';
      }

      $.ajax({
        url: testurl,
        type: 'GET',
        dataType: 'json',
        cache: false,
        success: function(data) {
          if (!isEmpty(data)) {
            var totalUnits = data.basketInfo.qty;
            //var totalprice = data.basketInfo.currencySymbol + data.basketInfo.totalPrice;

            $basketQuantity.html(totalUnits);
          }
        },
        error: function(xhr) {
          window.siteObj.fn.gaEventTrack('JavaScript Logs', 'Ajax Calls', 'Status: ' + xhr.status + ' | Text: ' + xhr.responseText);
        }
      });
    }
  };
  component.setupFunction2();

  var $doc = $(document);

  $doc.ready(function() { // DOM ready!

    // global variables

    var $body = $('body');
    var utils = window.siteObj.fn;
    var basket_utils = utils.basket;
    var isProduct = window.siteObj.type === 'product' ? true : false; // Check if it's product page (pre siteObj)
    var $prod_opts = $('.productoptions');
    var $quickviewTrigger = $('.quickview-hover'); // Quickview Trigger
    var $alertClose = $('.alert .close'); // Close alert notifications
    var $reviewSuccess = $('.review-success'); // Review Success
    var $popup = $('#size-charts a, .footer-links a[title~=Help], #checkout-help .panel-body a, #basketItems .delivery-message a, .basketItems .delivery-message a, #middle-rail .availability a, #prod-availability a'); // Size Guides
    var variations = document.querySelector('.js-fieldSet-variations') || document.querySelector('.productVariations');
    // Indicate that Add to Basket button is active on product pages
    var addToBasketButton = document.querySelectorAll('[data-e2e="addToBasketButton"]');

    if (addToBasketButton && addToBasketButton[0]) {
      addToBasketButton[0].setAttribute('data-initialized', 'true');
    }
    //
    //  Possible Waste Section
    //

    // Split the locale into seperable language/location
    if (typeof window.siteObj.selectedLang === 'undefined') {
      window.siteObj.selectedLang = window.siteObj.siteDefaultLocale.split('_')[0].toLowerCase();
      window.siteObj.countryCode = window.siteObj.siteDefaultLocale.split('_')[1].toLowerCase();
    }
    // Turns rel="external" into target="_blank" due to target being deprecated.
    $('a[href!=\'\'][rel*=\'external\']').attr('target', '_blank');

    // Fixes a bug in IE where a click event on an <img /> element doesn't bubble
    // up to it's parent <label /> so the associated form element isn't focussed.
    if ($.browser.msie) {
      $('label img').live('click', function() {
        var $this = $(this);
        $('#' + $this.closest('label').attr('for')).click();
      });
    }

    if ($('#middle-rail .panel:first').hasClass('campaign1')) {
      var currentCampaignSection = $('#campaign-header span').text();
      if (currentCampaignSection !== '') {
        currentCampaignSection = currentCampaignSection.replace('\'', '&#39;');
        $('.campaign-buttons a[title=\'' + currentCampaignSection + '\']').addClass('campaign-button-active');
      }
    }

    // check relevant radio button when fieldset is clicked in account section
    $('.resolve-card-problem #middle-rail fieldset').click(function() {
      var $this = $(this);
      $this.parent().parent().find('input[type=\'radio\']').attr('checked', 'checked');
    });

    // checkout hints
    $('.field, .placeOrder:first').addClass('showHint');
    //
    // End Possible Waste Section
    //

    // // Next Day Delivery show/hide legals
    $('.ndd-more-info, .read-more-button').click(function() {
      $('.ndd-message-legals, .more-brand-info-text').stop(true, true).slideToggle();
    });

    // product page subscriptions toggle content
    var $subscriptionsDetails = $('.subscriptions-details-js');
    $subscriptionsDetails.click(function() {
      $subscriptionsDetails.toggleClass('active');
    });

    // open and close function for article page read more
    /* Hide stuff to start */

    // close alert notifications
    $alertClose.click(function() {
      var $this = $(this);
      $this.parent().remove();
    });

    if ('ontouchstart' in document.documentElement === true) {
      $quickviewTrigger.addClass('quickview-touch-device');
    }

    // show / hide hints
    $('.field input, .field select[id!="cardType"], .field textarea').focus(function() {
      var $this = $(this);
      $this.parent().find('.hint:first').fadeIn(200);
    });
    $('.field input, .field select[id!="cardType"], .field textarea').blur(function() {
      var $this = $(this);
      $this.parent().find('.hint:first').fadeOut(200);
    });

    if (isProduct) {
      // Standard Reviews Anchor
      var reviewID = $('.write-review').closest('div[id]').not(':contains(' + window.siteObj.props.product.reviews.containsAverageRatingCheckText + ')').attr('id');
      $('#rating, .average').css('cursor', 'pointer').click(function() {
        location.hash = reviewID;
      });
    }

    $popup.on('click', function() {
      var url = $(this).attr('href');

      // check if there are query string parameters in the link already
      if (url.indexOf('?') === -1) {
        url += '?';
      } else {
        url += '&';
      }

      url += 'lang=' + window.siteObj.selectedLang + '&locale=' + window.siteObj.countryCode;

      var win = window.open(url, 'name', 'width=760,height=520,scrollbars=yes,resizable=yes');

      if (window.focus) {
        window.focus();
      }

      return win;
    });

    // customer services expand/collapse messages
    $('.discussion-detail').hide();

    $('.toggleDiscussion').text(window.siteObj.props.toggleDiscussion.viewBtn).click(function() {
      var $this = $(this);
      var discussionId = $this.attr('rel');
      var $discussionEl = $('#discussion-' + discussionId);

      if ($this.hasClass('collapse')) {
        $discussionEl.hide();
        $this.removeClass('collapse').text(window.siteObj.props.toggleDiscussion.viewBtn);
      } else {
        var fullUrl = '/' + $(location).attr('pathname').split('/')[1] + '/messageread.json';
        if ($('#alert-highlight').length) {
          $.ajax({
            type: 'POST',
            url: fullUrl,
            data: 'discussionId=' + discussionId
          });
        }
        $discussionEl.show();
        $this.addClass('collapse').text(window.siteObj.props.toggleDiscussion.hideBtn);
      }
    });

    /*
     Facets Accordion Collapse
     */
    var $facetPanel = $('#facets-panel');
    var $facetBody = $facetPanel.find('.facets-body');
    var $facetTitle = $facetPanel.find('.facets-title');

    /**
     * Toggle the facet panel
     * @param element
     * @param remove`
     * @param add
     * @param slide
     */
    function toggleFacetSection(element, remove, add, slide) {
      var $parent = element.parent();
      var $list = $parent.find('> ul, > dl');

      // allSole needs one more level up
      if (!$list.length) {
        $list = $parent.parent().find('> ul, > dl');
      }

      $parent.find('.facets-title').removeClass(remove).addClass(add);
      $list.stop(true, true)[slide](null, null, function() {
        if (slide === 'slideDown') {
          $list[0].setAttribute('style', '');
        }
      });
    }

    if ($facetBody !== null && $facetBody.length) {
      $facetBody.each(function() {
        var $this = $(this);
        if ($this.find('ul, dl').height() <= '200') {
          $this.addClass('facet-small');
        }
        $this.find('.facets-title').addClass('facet-open');
      });
    }

    if ($facetTitle !== null && $facetTitle.length) {
      var $document = $(document);
      $document.on('click', '.facets-title', function facetTitleClick() {
        var element = $(this);
        if (element.hasClass('facet-open') || !element.hasClass('facet-close')) {
          toggleFacetSection(element, 'facet-open', 'facet-close', 'slideUp');
          return false;
        }
        toggleFacetSection(element, 'facet-close', 'facet-open', 'slideDown');
        return false;
      });

    }

    // hide review thank you
    $reviewSuccess.delay(5000).slideUp(600);

    //
    //
    // START PRODUCT VARIATION
    //
    //
    // think about moving this into separate module
    //
    var blockCall = false;

    function getRadioValue(radios) {
      var retVal = '';
      $(radios).each(function() {
        if ($(this).attr('checked') === 'checked') {
          retVal = $(this).value;
          return;
        }
      });
      return retVal;
    }

    // Only apply the 'old' variations select change
    // events if the allvariations is explicitly false
    if (window.siteObj.features.product.allvariations === false) {

      var variationsSelect = $prod_opts.find('.field select');
      var variationsRadio = $prod_opts.find('.field input[type=\'radio\']');

      if (variationsSelect.length || variationsRadio.length) {

        var lastVariation = (variationsRadio.length) ? variationsRadio : variationsSelect[variationsSelect.length - 1];
        var variationValue = (variationsRadio.length) ? getRadioValue(variationsRadio) : lastVariation.value;

        if (variationValue === '') {
          // Disable the buy button until some options have been selected.
          if (window.siteObj.features.product.cheapestItemSelected !== 'true') {
            $prod_opts.find('.buying-area button').addClass('disabled').attr('disabled', 'disabled');
          }
        } else {
          if (variationsSelect && variationsSelect.length > 1 && variationsSelect[1].value) {
            blockCall = true;
          }
          $prod_opts.find('.buying-area button').removeClass('disabled').removeAttr('disabled');
        }
      }

      $doc.on('change', '.productoptions .field select, .productoptions .subscriptions .field input[type=\'radio\']', function() { // $(document).on event handler fix for issue with 'quickbuy with product options' change event

        // not being captured by jQ
        var $this = $(this);
        var isRadioOpts = ($(this).attr('type') === 'radio') ? 1 : 0;
        var val = $this.val();
        var $prod_opts = $this.parents('.productoptions').first();
        var idx = 0;

        // find the parent  productoptions of change event object
        if (val !== '') { // Check they've not selected the "Please select..." option.

          var $field_cont = $this.closest('.field');
          // Save the current index of the field so we can pick the correct
          // details out of the array in the returned JSON object.
          idx = $this.closest('.productoptions').find('.field').index($field_cont);

          var data = basket_utils.build_data($prod_opts, idx, isRadioOpts);
          basket_utils.selected_opts_arr[idx] = val;

          if ($('input[name=\'cheapest-product-id\']').length) {
            basket_utils.preselected_product = true;
          }

          // Fetch on field change.
          basket_utils.fetch_variations(data, $field_cont, idx);

          // Test to see if the UL.options-set is available
          // If it is set the correct li to .active

          var $optionsSet = $('ul.options-set');
          var $parentFieldset = $this.closest('fieldset');
          var $options = $this.find('option');
          var $optionSingleContent = $parentFieldset.find('.option-single').html();

          if ($optionsSet.length > 0 && $optionsSet.is(':visible')) {
            $parentFieldset
              .find('li')
              .removeClass('active')
              .end()
              .find('li[rel=' + $this.attr('value') + ']')
              .addClass('active');
          }

          if (window.siteObj.mvt && window.siteObj.mvt.hideVariationDropdowns === true) {
            if ($options.length === 1 || ($options.length === 2 && !$options.get(0).value)) {
              if ($optionSingleContent === undefined) {
                $this.css({
                  'left': '-9999px',
                  'position': 'absolute'
                });
                $this.parent().find('label').after('<div class="option-single">' + $options.get($options.length - 1).text + '</div>');
              }
            } else if ($this.parent().find('.option-single').length) {
              $this.parent().find('.option-single').remove();
              $this.css({
                'left': '0',
                'position': 'relative'
              });
            }
          }
        } else {
          window.siteObj.fn.basket.setSubscriptionInformation();
          basket_utils.variation_select(idx, basket_utils.original_price, basket_utils.original_saving_amount, basket_utils.original_saving_percent, basket_utils.original_price_rrp, $prod_opts);
        }
      })
        .find('option:selected')
        .click(function() {
          var $this = $(this);

          // Forces a change event on click of an already selected option.
          $this.parent().trigger('change');
        });

      $doc.on('submit', '.buying-area', function(e) {

        var $that = $(this);
        var button = $that.find('button');
        var $prod_opts = $that.closest('.productoptions');
        var $vars_form = $prod_opts;
        var product_id = $vars_form.find('input[name=\'buy\']').val() || false;
        var qty = basket_utils.get_qty();
        var completed = true;
        // Loop over all variations fields and get their values.
        var variationSelect = $vars_form.find('fieldset select');
        var variationRadio = $vars_form.find('fieldset input[type=\'radio\']'); // new radio buttons

        if (variationSelect.length) {
          variations = variationSelect.map(function(i) {
            var $this = $(this);

            // Prefix for each selected option so we
            // know which option group it's been picked from.
            var prefix = 'variation' + (i + 1);

            // Get the value of the selected option.
            var val = $this.find('option:selected').val();

            // Check an option has been selected...
            if (val.length > 0) {
              // Build up the option string based on the prefix
              // and the selected option.
              return prefix + '=' + prefix + ':' + val;
            }

            // This field has no value so the form is incomplete.
            else {
              completed = false;
            }
          }).get(); // Use .get() to return a native JS array rather than a jQuery object.

        } else if (variationRadio.length) {
          var val = '';
          variationRadio.each(function() {
            if ($(this).attr('checked')) {
              val = $(this).val();
              return;
            }
          });
          if (val !== '') {
            var prefix = 'variation1=variation1:' + val;
            variations = [prefix];
          } else {
            completed = false;
          }
        }

        // If we can't find a product ID then the
        // form element will simply submit as normal.
        if (product_id) {
          if (completed) {
            basket_utils.init_add(product_id, qty, button, variations);
          } else {
            app.publish('tracking/record', 'Variations', 'No Product Options Selected', window.siteObj.productID);
          }

          e.preventDefault();
        }
      });
    }

    if ($('input[name=\'cheapest-product-id\']').length) {
      basket_utils.preselected_product = true;
    } else {
      basket_utils.preSelector($prod_opts, 0, blockCall);
      if (blockCall) {
        blockCall = false;
      }
    }
    /*=====Quantity-Controls get Quantity function.====== */
    var qc_get_qty = function(obj) {

      var qty = 1;
      var btn = (obj && obj.length) ? obj[0] : 0;
      var nearestQtyFld;
      var parentContainerBlock = btn.closest('.js-buy-block');
      if (parentContainerBlock) {
        nearestQtyFld = parentContainerBlock.querySelector('.js-qc-qty');
        if (nearestQtyFld) {
          qty = nearestQtyFld.value;
        }
      }
      return qty;
    };

    // Handle Ajax basket for regular products.
    // Refresh the page as normal for the basket page products.
    // but not if not if basketBlock - new ajax basket exists
    if ((($('.secureqv').length) || ($body.attr('id') !== 'checkout')) && ($('section#basketBlock').length !== 1)) {
      $body.on('click', '.productbuy', function(e) {
        var $this = $(this);
        var product_id = utils.get_uri_param($this.attr('href'), 'buy'); // Get the product sku from the href.
        var isQcFlds = $('.js-qty-controls').length;
        var qty = (isQcFlds && typeof (qc_get_qty) === 'function') ? qc_get_qty($this) : basket_utils.get_qty();

        if (qty === 'undefined') {
          qty = 1;
        }

        // If we can't find a product ID then the anchor
        // element will simply click through as normal.
        if (product_id) {
          basket_utils.init_add(product_id, qty, $this);
          e.preventDefault();
        }
      });
    }

    // Handle people clicking on the disabled submit button before any options are selected
    $('.buying-area button[disabled=\'disabled\']').removeAttr('disabled');

    // get product-thumbnails working...
    $('.list-menu.product-thumbnails .list-item a').each(function() {
      $(this).attr('href', $(this).attr('data-href'));
    });
    //
    //
    // END PRODUCT VARIATION
    //
    //

    if (isProduct) {
      var jZoomUl = document.querySelector('.jZoom_ul');

      if (jZoomUl) {
        simpleProductjZoomThumbnails(variations, jZoomUl);
      }

      //until we fix/update the product page image code this will have to be a site specific function
      if (window.siteObj.siteCode === 'myprotein' || window.siteObj.siteCode === 'idealfit') {
        initVariationImagesUpdate();
      }
    }

  });

  // myprotein has code to hide images for items with colour-swatches
  // such as clothing, which hides images - this needs an override for some simple products with jZoom etc

  //End Document Ready

  function simpleProductjZoomThumbnails(variations, jZoomUl) {

    /*
    If the product has jZoom and no variations and thumbnails
    show the thumbnails - they are hidded because of the variation colour-swatches
    */

    var listItems = jZoomUl.querySelectorAll('.list-item');

    if (listItems.length && !variations) {
      for (var i = 0; i < listItems.length; i++) {
        listItems[i].style.visibility = 'visible';
      }
    }

  }

  function initVariationImagesUpdate() {

    if ((window.siteObj.type === 'product') && document) {

      var productOptions = document.querySelector('.productoptions');

      if (productOptions) {
        var colourSwatchesSelector = productOptions.querySelector('[data-component="colourswatches"] + select');
        var variationImage = document.querySelector('[data-product-main-image-variation-images="true"]');

        // if we have colour swatches the selector will be triggered and the images will be unhidden
        // for variation products without colourswatches we need to unhide the images
        // variation images and no colourswatches - unhide images

        if (!colourSwatchesSelector && variationImage) {
          variationImage.style.visibility = 'visible';
        }

        if (colourSwatchesSelector) {
          $(colourSwatchesSelector).trigger('change');
        }
      }
    }
  }




  /**
   Test if a JSON object is empty.
   **/

  function isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return true;
  }

  // Basket Upgrade
  $('.js-basket-upgrade-remove, .btn-basket-upgrade-add').click(function() {
    $('.alert-basket-upgrade').remove();
  });

  // Require global tracking
  require(['gtmScript']);
  return component;
});
